// extracted by mini-css-extract-plugin
export default {"cardLoader":"styles_cardLoader__nXgzo"};